@if(showResetPage){
<div class="container">
  <div class="row align-items-center flex-res r-form">
    <div class="col-md-5 center_page">
      <div class="card px-80">
        <div class="">
          <div class="register-form">
            <div class="px-0 pt-5 mb-4">
              <p class="text-center">
                <img alt="" class="r_image" src="assets/images/side-nav/cc_original@2x.png" />
              </p>
              <div class="col-lg-12 mt-50">
                <div class="">
                  <form [formGroup]="resetForm" (ngSubmit)="resetPassword()">
                    <div class="form-floating left-labeled">
                      <label for="new_password" id="new_password_label">
                        New password (8 or more characters)
                      </label>
                      <div class="d-flex name-input">
                      <input [type]="showPasswordNew ? 'text' : 'password'" id="new_password" aria-labelledby="new_password_label"
                        class="form-control input-sm chat-input" formControlName="new_password"
                        placeholder="New password" (input)="checkPasswordRequirements()" />
                        <button type="button" class="input-group-text" (click)="togglePasswordNew()" style="cursor: pointer;">
                            <i class="bi" [ngClass]="showPasswordNew ? 'bi-eye-slash' : 'bi-eye'"></i>
                        </button>
                        </div>
                    </div>

                    <!-- Password requirements box -->
                    <div class="password-req-box mt-15" [ngClass]="{
                        invalid: !allRequirementsMet,
                        valid: allRequirementsMet
                      }">
                      <div class="mb-1 txt-regular">
                        Your password needs to:
                      </div>
                      <ul class="mb-0 txt-regular">
                        <li>
                          <span [ngClass]="{
                              'req-met': reqs.lowerUpper,
                              'req-not-met': !reqs.lowerUpper
                            }">
                            <i *ngIf="reqs.lowerUpper" class="bi bi-check-circle-fill text-success"></i>
                            <i *ngIf="!reqs.lowerUpper" class="bi bi-x-circle-fill text-danger"></i>
                            Include both a lower and upper case character
                          </span>
                        </li>
                        <li>
                          <span [ngClass]="{
                              'req-met': reqs.length,
                              'req-not-met': !reqs.length
                            }">
                            <i *ngIf="reqs.length" class="bi bi-check-circle-fill text-success"></i>
                            <i *ngIf="!reqs.length" class="bi bi-x-circle-fill text-danger"></i>
                            Be at least 8 characters long
                          </span>
                        </li>
                        <li>
                          <span [ngClass]="{
                              'req-met': reqs.numberOrSymbol,
                              'req-not-met': !reqs.numberOrSymbol
                            }">
                            <i *ngIf="reqs.numberOrSymbol" class="bi bi-check-circle-fill text-success"></i>
                            <i *ngIf="!reqs.numberOrSymbol" class="bi bi-x-circle-fill text-danger"></i>
                            Include one number and symbol
                          </span>
                        </li>
                      </ul>
                    </div>

                    <div class="form-floating left-labeled mt-15">
                      <label for="re_enter_password" id="re_enter_password_label">
                        Re enter password
                      </label>
                      <div class="d-flex name-input">
                        <input [type]="showPassword ? 'text' : 'password'" type="password" id="re_enter_password" aria-labelledby="re_enter_password_label"
                        class="form-control input-sm chat-input" formControlName="re_enter_password"
                        placeholder="Re enter password" />
                        <button type="button" class="input-group-text" (click)="togglePassword()" style="cursor: pointer;">
                            <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                        </button>
                      </div>
                      <div *ngIf="
                          resetForm.get('re_enter_password')?.touched &&
                          resetForm.hasError('passwordMismatch')
                        " class="text-danger fs-12 mt-2">
                        Passwords do not match.
                      </div>
                    </div>

                    <div class="mt-15">
                      <button type="submit" aria-label="Reset password" class="btn w-100 cc_p_btn fs_13"
                        [disabled]="!allRequirementsMet || resetForm.invalid">
                        Reset password
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}@else if(!showEmptyState && !showResetPage) {
<div class="container">
  <div class="row align-items-center">
    <div class="col-12 text-center user-title-m fs-23 mt-100 mb-100">
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#e74c3c" class="bi bi-x-circle"
        viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
        <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
      </svg>

      <p class="mt-20">The reset link is invalid or has expired.</p>
      <a class="txt-regular fs-16">Please wait... will be redirected shortly.</a>
    </div>
  </div>
</div>
}